export default __webpack_public_path__ + "static/media/Group Setting  Step by step Wite.3cfc2f70.svg";